/** Fellido · Bewertungen — echte Seiten-Pagination ohne Neuladen. */
(function () {
  function initPager(section) {
    if (section.dataset.fRevInit) return;
    section.dataset.fRevInit = '1';

    var list = section.querySelector('[data-f-rev-list]');
    var pager = section.querySelector('[data-f-rev-pager]');
    if (!list || !pager) return;

    var perPage = Number(list.dataset.perPage) || 4;
    var cards = Array.prototype.slice.call(list.querySelectorAll('.f-rev__card'));
    var pageCount = Math.max(1, Math.ceil(cards.length / perPage));
    var pageButtons = Array.prototype.slice.call(pager.querySelectorAll('[data-f-rev-page]'));
    var prev = pager.querySelector('[data-f-rev-prev]');
    var next = pager.querySelector('[data-f-rev-next]');
    var current = 1;

    function render(page, scroll) {
      current = Math.min(Math.max(1, page), pageCount);
      cards.forEach(function (card, i) {
        card.hidden = (Math.floor(i / perPage) + 1) !== current;
      });
      pageButtons.forEach(function (btn) {
        var on = Number(btn.dataset.fRevPage) === current;
        btn.classList.toggle('is-active', on);
        if (on) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = current === 1;
      if (next) next.disabled = current === pageCount;
      if (scroll && list.getBoundingClientRect().top < 0) {
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    pageButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { render(Number(btn.dataset.fRevPage), true); });
    });
    if (prev) prev.addEventListener('click', function () { render(current - 1, true); });
    if (next) next.addEventListener('click', function () { render(current + 1, true); });

    render(1, false);
  }

  function init() {
    document.querySelectorAll('[data-testid="f-reviews"]').forEach(initPager);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
